import { createActionTypes } from "lib/utils/createActionTypes";

export default class UIDucks {
  public static initialState = {
    navBarOpen: false
  };

  public static duckName = "UI";

  public static actionTypes: any = createActionTypes(
    {
      getIsNavBarOpen: "get_is_nav_bar_open".toUpperCase(),
      setNavBar: "set_nav_bar".toUpperCase(),
    },
    UIDucks.duckName
  );

  public static getOwnState = state =>
    state[UIDucks.duckName] || UIDucks.initialState;

  public static getState(state) {
    return state;
  }

  public static getIsNavBarOpen(state) {
    return this.getOwnState(state).navBarOpen;
  }

  public static setNavBar = (open: boolean = false) => dispatch => {
    dispatch({
      type: UIDucks.actionTypes.setNavBar,
      payload: { navBarOpen: open }
    });
  };

  public static reducer(state = UIDucks.initialState, action) {
    switch (action.type) {
      case UIDucks.actionTypes.setNavBar:
        return {
          ...state,
          navBarOpen: action.payload.navBarOpen
        };
      default:
        return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/ducks/UI.duck.ts